import { AppBar, Dialog, IconButton, Grid, Toolbar, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { PrivacySelect } from './PrivacySelect';
import { VideoFileSelect } from './VideoFileSelect';
import { UploadButton } from './UploadButton';
import { TitleTextField } from './TitleTextField';
import { DescriptionTextField } from './DescriptionTextField';

type Props = {
    open: boolean;
    onClose: () => void;
}

export const VideoUploadDialog = ({ open, onClose }: Props) => {
    return (
        <Dialog fullScreen open={open} onClose={onClose}>
            <AppBar sx={{ position: 'relative' }}>
                <Toolbar>
                    <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                        動画アップロード
                    </Typography>
                    <IconButton edge="start" color="inherit" onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </Toolbar>
            </AppBar>
            <Grid container direction="column" pt={3} px={2} spacing={2}>
                <Grid item>
                    <PrivacySelect />
                </Grid>
                <Grid item>
                    <TitleTextField />
                </Grid>
                <Grid item>
                    <DescriptionTextField />
                </Grid>
                <Grid item>
                    <VideoFileSelect />
                </Grid>
                <Grid item container justifyContent="center" mt={6}>
                    <UploadButton />
                </Grid>
            </Grid>
        </Dialog>
    )
}
